import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { AntimalwareOnDemandScanTask } from '@nirvana/shared/dtos/types/policies/common';
import { AntimalwareOnDemandScanTaskFormValue } from '../../../../../../utils/uiSettings/antimalware/antimalware.types';

// validate duplicates
export function validateDuplicates(
  ruleItem: AntimalwareOnDemandScanTaskFormValue,
  rulesInGrid: AntimalwareOnDemandScanTask[]
): ValidationResult {
  const hasDuplicates = rulesInGrid.some(
    (ruleInGrid: AntimalwareOnDemandScanTask) => ruleInGrid.taskName === ruleItem.taskName
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
